import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AuditCalendar from "./AuditCalendar";

export default function CalendarModal({
  open,
  onClose,
  onDateChange,
  selectedDate,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.85)",
          backdropFilter: "blur(100px)",
          boxShadow: "0 8px 32px rgba(0, 0, 0, 0.1)",
          borderRadius: "12px",
          border: "2px solid #4F46E5",
          overflow: "hidden",
          background:
            "linear-gradient(135deg, rgba(255,255,255,0.9) 25%,rgb(216, 215, 221) 50%)",
        },
      }}
    >
      <DialogContent
        dividers
        sx={{
          background: "transparent",
          borderTop: "none",
          borderBottom: "none",
          position: "relative",
          "&::after": {
            content: '""',
            position: "absolute",
            bottom: 0,
            right: 0,
            width: "50%",
            height: "50%",
            background:
              "linear-gradient(135deg, transparent 70%, #4F46E5 200%)",
            // borderRadius: "0 0 0 0",
            pointerEvents: "none",
          },
        }}
      >
        <Box
          sx={{
            p: 1,
            position: "relative",
            zIndex: 1,
            "& .MuiPickersDay-root.Mui-selected": {
              backgroundColor: "#4F46E5",
              color: "white",
              borderRadius: "50%",
            },
            "& .MuiPickersCalendarHeader-label": {
              fontWeight: "bold",
            },
            "& .MuiIconButton-root": {
              color: "#4F46E5",
            },
          }}
        >
          <AuditCalendar
            selectedDate={selectedDate}
            onDateChange={onDateChange}
            onAuditCreated={onClose} // Add this to trigger refresh when date is selected
          />
        </Box>
      </DialogContent>
    </Dialog>
  );
}
